import React, { useState } from 'react';
import { sendContactMail } from '../../../http/mailAPI';
import './mail.scss';
import { Trans } from '@lingui/react';
import { i18n } from "@lingui/core";
import MessageSendModal from '../../modals/MessageSendModal';

const Mail = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [modalVisible, setModalVisible] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        from: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        text: formData.message
      };

      const response = await sendContactMail(payload);
      setModalVisible(true);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container container-heaight-control mt-5">
      {/* <h2>Contact Us</h2> */}
      <form onSubmit={handleSubmit}>
        <div>
          <div className="mb-3">
            {/* <label className="form-label">Name</label> */}
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-control"
              placeholder={i18n._("namePlaceholder")}
            />
          </div>

          <div className="mb-3">
            {/* <label className="form-label">Email</label> */}
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
              placeholder={i18n._("emailPlaceholder")}
            />
          </div>

          <div className="mb-3">
            {/* <label className="form-label">Phone</label> */}
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-control"
              placeholder={i18n._("phonePlaceholder")}
            />
          </div>

          <div className="mb-3">
            {/* <label className="form-label">Subject</label> */}
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className="form-control"
              placeholder={i18n._("subjectPlaceholder")}
            />
          </div>
        </div>

        <div>


          <div className="mb-3">
            {/* <label className="form-label">Message</label> */}
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="form-control"
              placeholder={i18n._("messagePlaceholder")}
            ></textarea>
          </div>
          {/* <button type="submit" className="btn btn-primary">
            Send Message
          </button> */}
          <button type="submit" class="ant-btn css-dev-only-do-not-override-mc1tut ant-btn-default ant-btn-color-default ant-btn-variant-outlined booking">
            <span><Trans id="sendMessage" /></span>
          </button>
        </div>

      </form>
      <MessageSendModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </div>
  );
};

export default Mail;
